import * as Yup from "yup";

/**
 * Validation schema for contact form
 */
export const contactFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name is too short")
    .max(100, "Name is too long")
    .required("Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  company: Yup.string().max(100, "Company name is too long"),
  message: Yup.string()
    .min(10, "Message is too short")
    .max(1000, "Message is too long")
    .required("Message is required"),
});
